export default __webpack_public_path__ + "static/media/headset13.633b6fe0.jfif";